import React, { memo } from 'react';
import { Tooltip } from 'antd';
import { AssetItemDto } from '@api/Api';
import { ReactComponent as FolderSvg } from '@assets/icons/folder.svg';
import { ReactComponent as PrivateFolderSvg } from '@assets/icons/folder-private.svg';
import { FolderWithItems } from '@pages/Campaigns/CampaignReview/utils';

import ActionFolder from '@pages/Campaigns/CampaignReview/components/Actions/ActionFolder';

import TilesViewItem from './TilesViewItem';

import './TilesView.less';

type TilesViewProps = {
  onSelectFolder: (folderId: string) => void;
  onOpenAsset: (asset: AssetItemDto) => void;
  folders: FolderWithItems[];
  assetsList: AssetItemDto[];
  isOpenFolder: boolean;
  canManageReviews: boolean;
  reviewId: string;
};
export default memo(function TilesView({
  onSelectFolder,
  onOpenAsset,
  folders,
  assetsList,
  isOpenFolder,
  canManageReviews,
  reviewId
}: TilesViewProps) {
  return (
    <div className="campaign-review-tiles-view">
      {!!folders?.length && !isOpenFolder && (
        <div className="campaign-review-tiles-view-folders">
          <div className="campaign-review-tiles-view-label">Folders</div>
          <div className="campaign-review-tiles-view-folders-list">
            {folders.map((folder) => {
              const assetsDownloadUrls = folder.items
                .filter((asset) => !!asset.asset?.permissions.download)
                .map((asset) => asset.asset?.versions[0].sourceUrl)
                .filter((url): url is string => !!url);
              return (
                <div
                  className="campaign-review-tiles-view-folder"
                  key={folder.id}
                  onClick={() => onSelectFolder(folder.id)}
                >
                  {folder.isPrivate ? <PrivateFolderSvg /> : <FolderSvg />}
                  <div className="campaign-review-tiles-view-folder-name">
                    <Tooltip
                      title={folder.name}
                      overlayClassName="toggle_favorite_overlay toggle_favorite_overlay--small"
                    >
                      {folder.name}
                    </Tooltip>
                  </div>
                  <ActionFolder
                    canManageReviews={canManageReviews}
                    assetsDownloadUrls={assetsDownloadUrls}
                    folderName={folder.name}
                    reviewId={reviewId}
                    folderId={folder.id}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!!assetsList?.length && (
        <div className="campaign-review-tiles-view-assets">
          <div className="campaign-review-tiles-view-label">Media</div>
          <div className="campaign-review-tiles-view-assets-list">
            {assetsList.map((item) => {
              return (
                <TilesViewItem
                  key={item.id}
                  asset={item}
                  onOpenAsset={onOpenAsset}
                  canManageReviews={canManageReviews}
                  reviewId={reviewId}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
});
